import styled from "styled-components";
import { CenterFlexColumn, CenterFlexRow } from "styles/layout";

export const TrackGridContainer = styled(CenterFlexRow)`
  flex-wrap: wrap;
  gap: 10px;
`;

const Name = styled.span`
  color: white;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
`;

export const TrackName = styled(Name)`
  font-size: 15pt;
  font-weight: 800;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
  max-width: 100%;
`;

export const MapperName = styled(Name)`
  font-size: 10pt;
  font-weight: 600;
  letter-spacing: 1px;
  margin-top: -2px;
`;

export const TmioButton = styled.a`
  display: none;
  position: absolute;
  top: 4px;
  right: 4px;
  width: 28px;
  height: 28px;
  background-image: url("/images/tmio/logo_white.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  text-decoration: none;
  cursor: pointer;
  color: white;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;

  &:hover {
    background-image: url("/images/tmio/logo.png");
  }
`;

export const TrackGridItemWrapper = styled.div<{
  backgroundUrl: string;
}>`
  position: relative;
  width: 190px;
  height: 110px;
  background-image: url(${(p) => p.backgroundUrl});
  cursor: pointer;
  background-position: center;
  background-size: cover;
  filter: brightness(70%);
  text-align: center;

  &:hover {
    filter: brightness(100%);
  }

  &:hover ${TmioButton} {
    display: block;
  }
`;

export const TrackGridItemDetails = styled(CenterFlexColumn)`
  height: 100%;
  padding: 5px;
  box-sizing: border-box;
`;
